import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "fields", "modeSelect", "editor"]

  toggle() {
    if (this.toggleTarget.checked) {
      this.fieldsTarget.classList.remove("hidden")
      if (this.hasEditorTarget) {
        this.editorTarget.classList.remove("hidden")
      }
      // Set default mode if empty
      if (this.hasModeSelectTarget && !this.modeSelectTarget.value) {
        this.modeSelectTarget.value = "replace"
      }
    } else {
      this.fieldsTarget.classList.add("hidden")
      if (this.hasEditorTarget) {
        this.editorTarget.classList.add("hidden")
      }
      // Clear the mode when toggled off
      if (this.hasModeSelectTarget) {
        this.modeSelectTarget.value = ""
      }
    }
  }
}
